import { s, c, t } from '../val.config';

export const employeeSchema = s
  .object({
    email: s.string(),
    image: s.image(),
    name: s.string(),
    hide: s.boolean(),
    phoneNumber: s.string(),
    position: s.union(
      s.literal('Daglig Leder'),
      s.literal('Salgssjef'),
      s.literal('Teknolog'),
      s.literal('Leder Teknologi'),
      s.literal('Fagsjef Teknologi'),
      s.literal('Designer'),
      s.literal('Leder Design'),
      s.literal('Fagsjef Design'),
      s.literal('Office manager'),
      s.literal('Leder for vekst og talent')
    ),
    contactPerson: s.boolean(),
  })
  .preview(({ val }) => {
    return {
      title: val.name,
      subtitle: val.position,
      image: val.image,
    };
  });
export type Employee = t.inferSchema<typeof employeeSchema>;
export const schema = s.record(employeeSchema);

export default c.define('/data/employees.val.ts', schema, {
  lee: {
    email: `lf@blank.no`,
    hide: false,
    image: {
      path: '/public/val/leefrost-2018-06utendrsportretteravblank-ansatte-120_f98e0.jpg',
      width: 2048,
      height: 1365,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.5063649222065064, y: 0.4371715162065821 },
      alt: 'Bilde av Lee',
    },
    name: `Lee Frost`,
    phoneNumber: `45813884`,
    position: `Fagsjef Design`,
    contactPerson: false,
  },
  clara: {
    email: `clara@blank.no`,
    hide: false,
    image: {
      path: '/public/val/clarapatek-2020-08utendrsportretterblank-1278_45b79.jpg',
      width: 2048,
      height: 1365,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.6049046321525886, y: 0.5192034366566058 },
    },
    name: `Clara Patek`,
    phoneNumber: `46116241`,
    position: `Teknolog`,
    contactPerson: false,
  },
  anja: {
    email: `anja@blank.no`,
    hide: false,
    image: {
      path: '/public/val/anjastedjeberghansen-2020-08utendrsportretterblank-1389_cffb2.jpg',
      width: 2048,
      height: 1365,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.57991513437058, y: 0.4286827489015999 },
    },
    name: `Anja Stedjeberg Hansen`,
    phoneNumber: `48069352`,
    position: `Designer`,
    contactPerson: false,
  },
  isak: {
    email: `isak.bjornstad@blank.no`,
    hide: false,
    image: {
      path: '/public/val/isakbjrnstad-2021-08utendrsportretteravblank-ansatte-349_890c5.jpg',
      width: 2048,
      height: 1365,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.48797736916548795, y: 0.25678521097571083 },
    },
    name: `Isak Grande Bjørnstad`,
    phoneNumber: `94425952`,
    position: `Teknolog`,
    contactPerson: false,
  },
  emilie: {
    email: `emilie.maehlum@blank.no`,
    hide: false,
    image: {
      path: '/public/val/emiliemhlum-2020-08utendrsportretterblank-22_ded0b.jpg',
      width: 2048,
      height: 1365,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.5283333333333333, y: 0.18504698458593002 },
    },
    name: 'Emilie Mæhlum',
    phoneNumber: `99303615`,
    position: `Teknolog`,
    contactPerson: false,
  },
  magne: {
    email: 'mkd@blank.no',
    hide: false,
    image: {
      path: '/public/val/2015-09jdo-portretter-40_c07cf.jpg',
      width: 2048,
      height: 1638,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.49727520435967304, y: 0.408 },
    },
    name: 'Magne Davidsen',
    phoneNumber: '40221672',
    position: 'Leder Teknologi',
    contactPerson: false,
  },
  erlend: {
    email: 'ea@blank.no',
    hide: false,
    image: {
      path: '/public/val/erlendamdal-2020-08utendrsportretterblank-820_df718.jpg',
      width: 2048,
      height: 1365,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.5081743869209809, y: 0.49058592439994253 },
    },
    name: 'Erlend Åmdal',
    phoneNumber: '456 98 346',
    position: 'Teknolog',
    contactPerson: false,
  },
  trond: {
    email: 'to@blank.no',
    hide: false,
    image: {
      path: '/public/val/trondydna-2020-08utendrsportretterblank-1319_bd00e.jpg',
      width: 2048,
      height: 1365,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.6283333333333333, y: 0.3875984136597183 },
      alt: 'Bilde av han Trond',
    },
    name: 'Trond Øydna',
    phoneNumber: '975 22 417',
    position: 'Teknolog',
    contactPerson: false,
  },
  fredrik: {
    email: 'fe@blank.no',
    hide: false,
    image: {
      path: '/public/val/generatedimageseptember172025-9_06am_59035.png',
      alt: 'Fredrik Ekholdt',
      width: 1248,
      height: 832,
      mimeType: 'image/png',
      hotspot: { x: 0.5266666666666666, y: 0.2775 },
    },
    name: 'Fredrik Ekholdt',
    phoneNumber: '99000705',
    position: 'Teknolog',
    contactPerson: false,
  },
  zaim: {
    email: 'zaim.imran@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/9e19025836290b3cf37fae16a00aaf1d3ffbcc57-4724x3149.webp',
      width: 4724,
      height: 3149,
      mimeType: 'image/webp',
      hotspot: { x: 0.4986376021798365, y: 0.6560643801494539 },
    },
    name: 'Zaim Imran',
    phoneNumber: '401 70 752',
    position: 'Teknolog',
    contactPerson: false,
  },
  sandra: {
    email: 'sandra.kofoed@blank.no',
    hide: false,
    image: {
      path: '/public/val/sandra-kofoed-6_31521.jpg',
      width: 6240,
      height: 4160,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.6483333333333333, y: 0.37 },
    },
    name: 'Sandra Kofoed',
    phoneNumber: '90899996',
    position: 'Designer',
    contactPerson: false,
  },
  astri: {
    email: 'astri.eiterstraum@blank.no',
    hide: false,
    image: {
      path: '/public/val/dscf6653_ade00.jpg',
      width: 6240,
      height: 4160,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.64, y: 0.2125 },
    },
    name: 'Astri Eiterstraum',
    phoneNumber: '942 94 902',
    position: 'Designer',
    contactPerson: false,
  },
  skjelbek: {
    email: 'ls@blank.no',
    hide: false,
    image: {
      path: '/public/val/larsloennechenskjelbek-2019-06utendrsportretterblank-163_2fa86.jpg',
      width: 1638,
      height: 2048,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.5136239782016349, y: 0.35 },
    },
    name: ' Lars Skjelbek',
    phoneNumber: '480 77 580',
    position: 'Teknolog',
    contactPerson: false,
  },
  sooyeong: {
    email: 'soo.yeong.song@blank.no',
    hide: false,
    image: {
      path: '/public/val/sooyeongsong-2022-01utendrsportretteravblank-ansatte-160_82fa1.jpg',
      width: 1638,
      height: 2048,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.6851739699533085, y: 0.19000296879638745 },
    },
    name: 'Soo Yeong Song',
    phoneNumber: '973 18 259',
    position: 'Designer',
    contactPerson: false,
  },
  lisa: {
    email: 'lisa@blank.no',
    hide: false,
    image: {
      path: '/public/val/lisaottesen-2019-06utendrsportretterblank-40_7ff05.jpg',
      width: 2048,
      height: 1638,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.48365122615803813, y: 0.404 },
    },
    name: ' Lisa Ottesen',
    phoneNumber: '482 12 169',
    position: 'Teknolog',
    contactPerson: false,
  },
  korsnes: {
    email: 'jk@blank.no',
    hide: false,
    image: {
      path: '/public/val/2015-09jdo-portretter-7_77631.jpg',
      width: 2048,
      height: 1638,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.47275204359673023, y: 0.338 },
    },
    name: 'John Korsnes',
    phoneNumber: '95939807',
    position: 'Teknolog',
    contactPerson: false,
  },
  smeby: {
    email: 'lars@blank.no',
    hide: false,
    image: {
      path: '/public/val/larssmeby-2021-11utendrsportrettblank-ansatte-110_4d433.jpg',
      width: 2048,
      height: 1366,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.5354223433242506, y: 0.29822069735897233 },
    },
    name: 'Lars Smeby',
    phoneNumber: '412 10 297',
    position: 'Teknolog',
    contactPerson: false,
  },
  ingrid: {
    email: 'im@blank.no',
    hide: false,
    image: {
      path: '/public/val/ingridmoen-2020-08utendrsportretterblank-1375_dda16.jpg',
      width: 2048,
      height: 1365,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.39509536784741145, y: 0.4272185758316166 },
    },
    name: 'Ingrid Elisabeth Moen',
    phoneNumber: '988 49 544',
    position: 'Teknolog',
    contactPerson: false,
  },
  terje: {
    email: 'tu@blank.no',
    hide: false,
    image: {
      path: '/public/val/terjeuglebakken-2020-08utendrsportretterblank-81_fb0a8.jpg',
      width: 2048,
      height: 1365,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.49318801089918257, y: 0.39042463150162093 },
    },
    name: 'Terje Uglebakken',
    phoneNumber: '918 60 882',
    position: 'Teknolog',
    contactPerson: false,
  },
  yngvar: {
    email: 'yj@blank.no',
    hide: false,
    image: {
      path: '/public/val/yngvarjohnsen-2016-09utedaghosblank-1133_2167b.jpg',
      width: 2048,
      height: 1638,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.45776566757493187, y: 0.396 },
    },
    name: 'Yngvar Johnsen',
    phoneNumber: '909 68 606',
    position: 'Teknolog',
    contactPerson: false,
  },
  cornelia: {
    email: 'cornelia.moe@blank.no',
    hide: false,
    image: {
      path: '/public/val/cornelia-schmitt-1_02251.jpg',
      width: 6240,
      height: 4160,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.6416893732970027, y: 0.3617204713095124 },
      alt: 'Cornelia Moe',
    },
    name: 'Cornelia Moe',
    phoneNumber: '988 62 571',
    position: 'Designer',
    contactPerson: false,
  },
  vilde: {
    email: 'vilde.hurum@blank.no',
    hide: false,
    image: {
      path: '/public/val/vildeinnsethurum2022-059_49ec7.jpg',
      width: 6240,
      height: 4160,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.21166666666666667, y: 0.3175 },
    },
    name: 'Vilde Innset Hurum',
    phoneNumber: '91894462',
    position: 'Teknolog',
    contactPerson: false,
  },
  andreas: {
    email: 'andreas.jonassen@blank.no',
    hide: false,
    image: {
      path: '/public/val/andreas-jensen-jonassen-15_ace5d.jpg',
      width: 6240,
      height: 4160,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.5640326975476839, y: 0.41076731487690393 },
    },
    name: 'Andreas Jensen Jonassen',
    phoneNumber: '41340095',
    position: 'Teknolog',
    contactPerson: false,
  },
  thea: {
    email: 'thea.nilsen@blank.no',
    hide: true,
    image: {
      path: '/public/val/thea-basthus-nilsen-15_74f92.jpg',
      width: 6240,
      height: 4160,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.6634877384196185, y: 0.40668007791295463 },
    },
    name: 'Thea Basthus Nilsen',
    phoneNumber: '90890497',
    position: 'Designer',
    contactPerson: false,
  },
  olejacob: {
    email: 'oj@blank.no',
    hide: false,
    image: {
      path: '/public/val/oj_1712a.avif',
      width: 3504,
      height: 2336,
      mimeType: 'image/avif',
      hotspot: { x: 0.6485013623978202, y: 0.3167575063578637 },
    },
    name: 'Ole Jacob Eriksen Syrdahl',
    phoneNumber: '959 39 804',
    position: 'Fagsjef Teknologi',
    contactPerson: false,
  },
  mads: {
    email: 'mn@blank.no',
    hide: false,
    image: {
      path: '/public/val/madsnyborg-2016-09utedaghosblank-451_ac55f.jpg',
      width: 1638,
      height: 2048,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.48092643051771117, y: 0.38 },
    },
    name: 'Mads Nyborg',
    phoneNumber: '959 39 813',
    position: 'Teknolog',
    contactPerson: false,
  },
  knut: {
    email: 'kb@blank.no',
    hide: false,
    image: {
      path: '/public/val/knut_4d348.avif',
      width: 1715,
      height: 2115,
      mimeType: 'image/avif',
      alt: 'Knut Magnus Backer - Salgssjef Blank',
      hotspot: { x: 0.5081743869209809, y: 0.118 },
    },
    name: 'Knut Magnus Backer',
    phoneNumber: '99797799',
    position: 'Salgssjef',
    contactPerson: true,
  },
  jahnarne: {
    email: 'jaj@blank.no',
    hide: false,
    image: {
      path: '/public/val/2019-03uteportretterblank-16(1)_553a6.jpg',
      width: 5584,
      height: 3723,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.465, y: 0.2699789078978205 },
      alt: 'Bilde av Jahn Arne',
    },
    name: 'Jahn Arne Johnsen',
    phoneNumber: '98219394',
    position: 'Daglig Leder',
    contactPerson: true,
  },
  kevin: {
    email: 'kevin@blank.no',
    hide: false,
    image: {
      path: '/public/val/kevin-halvarsson-14_15f16.jpg',
      width: 6240,
      height: 4160,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.5953678474114441, y: 0.335153431043842 },
    },
    name: 'Kevin Mentzoni Halvarsson',
    phoneNumber: '47449912',
    position: 'Teknolog',
    contactPerson: false,
  },
  neva: {
    email: 'neva.rustad@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/06368c63f9e95a1c40c7b8895ff845c847965766-6240x4160.webp',
      width: 6240,
      height: 4160,
      mimeType: 'image/webp',
      hotspot: { x: 0.5266666666666666, y: 0.295 },
    },
    name: 'Neva Linn Rustad',
    phoneNumber: '934 94 521',
    position: 'Designer',
    contactPerson: false,
  },
  bernholdt: {
    email: 'jbo@blank.no',
    hide: false,
    image: {
      path: '/public/val/jonbernholtolsen-2016-09utedaghosblank-722(1)_8e5c4.jpg',
      width: 1014,
      height: 1244,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.6649414380738782, y: 0.44400693760840015 },
    },
    name: ' Jon Bernholdt  Olsen',
    phoneNumber: '98219371',
    position: 'Leder Design',
    contactPerson: false,
  },
  'lars-ive': {
    email: 'lig@blank.no',
    hide: true,
    image: {
      path: '/public/val/images/d1b87c263fac4e67a37410cddbea9015cbbcad22-6240x4160.webp',
      width: 6240,
      height: 4160,
      mimeType: 'image/webp',
      hotspot: { x: 0.34, y: 0.325 },
    },
    name: 'Lars-Ive Gjærder',
    phoneNumber: '92895785',
    position: 'Designer',
    contactPerson: false,
  },
  bendik: {
    email: 'bendik@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/cf77ea703db7ec8b92d3474ba0e99e5c20325510-6240x4160.webp',
      width: 6240,
      height: 4160,
      mimeType: 'image/webp',
      hotspot: { x: 0.5880503144654088, y: 0.3160377358490566 },
    },
    name: 'Bendik Schrøder',
    phoneNumber: '979 87 660',
    position: 'Designer',
    contactPerson: false,
  },
  petter: {
    email: 'petter.barhaugen@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/61437667149b696faae6e87ce5308c733844dc2d-6240x4160.webp',
      width: 6240,
      height: 4160,
      mimeType: 'image/webp',
      hotspot: { x: 0.5911949685534591, y: 0.330188679245283 },
    },
    name: 'Petter Juterud Barhaugen',
    phoneNumber: '469 60 023',
    position: 'Teknolog',
    contactPerson: false,
  },
  max: {
    email: 'pepsi-max@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/0300c54992399710f6e63f43e06450a58fa90af9-6240x4160.webp',
      width: 6240,
      height: 4160,
      mimeType: 'image/webp',
      hotspot: { x: 0.5628930817610063, y: 0.35377358490566035 },
    },
    name: 'Max Torre Schau',
    phoneNumber: '917 82 159',
    position: 'Teknolog',
    contactPerson: false,
  },
  jonas: {
    name: 'Jonas Grimstad Lierstuen',
    email: 'jonas.lierstuen@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/jonas.webp',
      width: 6319,
      height: 4097,
      mimeType: 'image/webp',
    },
    position: 'Teknolog',
    contactPerson: false,
    phoneNumber: '',
  },
  nevena: {
    name: 'Nevena Dokic',
    email: 'nevena.dokic@blank.no',
    hide: true,
    image: {
      path: '/public/val/nevena_e9b98.avif',
      width: 1664,
      height: 2018,
      mimeType: 'image/avif',
      alt: 'Bilde av Nevena',
      hotspot: { x: 0.48501362397820164, y: 0.3 },
    },
    position: 'Designer',
    contactPerson: false,
    phoneNumber: '',
  },
  hermann: {
    email: 'hermann.elton@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/hermann.webp',
      width: 5423,
      height: 3738,
      mimeType: 'image/webp',
      hotspot: { x: 0.5366666666666666, y: 0.07495702438747946 },
    },
    name: 'Hermann Owren Elton',
    phoneNumber: '480 60 943',
    position: 'Teknolog',
    contactPerson: false,
  },
  sergey: {
    email: 'sergey@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/sergey.webp',
      width: 7008,
      height: 4672,
      mimeType: 'image/webp',
      hotspot: { x: 0.5717110339506173, y: 0.30246913580246915 },
    },
    name: 'Sergey Jakobsen',
    phoneNumber: '480 29 407',
    position: 'Teknolog',
    contactPerson: false,
  },
  olaf: {
    email: 'olaf.rosendahl@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/olaf.webp',
      width: 5538,
      height: 3944,
      mimeType: 'image/webp',
      hotspot: { x: 0.5866666666666667, y: 0.14041759608000878 },
    },
    name: 'Olaf Rosendahl',
    phoneNumber: '953 66 394',
    position: 'Teknolog',
    contactPerson: false,
  },
  jacob: {
    email: 'jacob.theisen@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/jacob.webp',
      width: 6013,
      height: 3935,
      mimeType: 'image/webp',
      hotspot: { x: 0.45666666666666667, y: 0.06876380349788097 },
    },
    name: 'Jacob Theisen',
    phoneNumber: '469 18 922',
    position: 'Teknolog',
    contactPerson: false,
  },
  vetle: {
    email: 'vetle.haadem@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/vetle.webp',
      width: 5282,
      height: 3675,
      mimeType: 'image/webp',
      hotspot: { x: 0.5533333333333333, y: 0.1533106261930606 },
      alt: 'yikes',
    },
    name: 'Vetle Hoel Haadem',
    phoneNumber: '413 60 182',
    position: 'Designer',
    contactPerson: false,
  },
  mathilde: {
    email: 'mathilde.tillman@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/a08597ec16ddf0d67819cbb3ca06487e9a62d050-6240x4160.webp',
      width: 6240,
      height: 4160,
      mimeType: 'image/webp',
      hotspot: { x: 0.8207547169811321, y: 0.24056603773584906 },
    },
    name: 'Mathilde Tillman Hegdal',
    phoneNumber: '476 29 273',
    position: 'Teknolog',
    contactPerson: false,
  },
  mira: {
    email: 'mira.krogh@blank.no',
    hide: false,
    image: {
      path: '/public/val/images/mira.webp',
      width: 5324,
      height: 3654,
      mimeType: 'image/webp',
      hotspot: { x: 0.5422343324250681, y: 0.22 },
    },
    name: 'Mira Beichmann Krogh',
    phoneNumber: '482 29 974',
    position: 'Designer',
    contactPerson: false,
  },
  'Filip Hagen': {
    hide: false,
    name: 'Filip Hagen',
    email: 'filip.hagen@blank.no',
    image: {
      path: '/public/val/filip_29c64.avif',
      width: 1502,
      height: 2016,
      mimeType: 'image/avif',
      alt: 'Filip Ha',
      hotspot: { x: 0.5122615803814714, y: 0.342 },
    },
    position: 'Teknolog',
    phoneNumber: '98091193',
    contactPerson: false,
  },
  'Lena Andersen': {
    email: ' lena.andersen@blank.no',
    image: {
      path: '/public/val/portrett_9e632.jpg',
      width: 4095,
      height: 6143,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.48092643051771117, y: 0.216 },
    },
    name: 'Lena Andersen',
    hide: false,
    phoneNumber: '',
    position: 'Leder for vekst og talent',
    contactPerson: false,
  },
  Nora: {
    hide: false,
    name: 'Nora Engan Haugen',
    email: 'nora.haugen@blank.no',
    image: {
      path: '/public/val/nora_a0162.jpg',
      alt: 'Nora Engan Haugen',
      width: 1200,
      height: 1800,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.48365122615803813, y: 0.276 },
    },
    position: 'Designer',
    phoneNumber: '',
    contactPerson: false,
  },
  'Johan Nicolai Troye': {
    hide: false,
    name: 'Johan Nicolai Troye',
    email: 'johan.troye@blank.no',
    image: {
      path: '/public/val/johannicolai_2d6b2.jpg',
      alt: 'Johan Nicolai Troye',
      width: 1200,
      height: 1800,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.5149863760217984, y: 0.26 },
    },
    position: 'Designer',
    phoneNumber: '',
    contactPerson: false,
  },
  'Sander Schrader': {
    hide: false,
    name: 'Sander Schrader',
    email: 'sander.schrader@blank.no',
    image: {
      path: '/public/val/sander_5b89a.jpg',
      alt: 'Sander Schrader',
      width: 1200,
      height: 1800,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.47956403269754766, y: 0.272 },
    },
    position: 'Teknolog',
    phoneNumber: '',
    contactPerson: false,
  },
  'Stian Sulebak': {
    hide: false,
    name: 'Stian Jørstad Sulebak',
    email: 'stian.sulebak@blank.no',
    image: {
      path: '/public/val/stian_696b2.jpg',
      alt: 'Stian Jørstad Sulebak',
      width: 1200,
      height: 1800,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.48637602179836514, y: 0.272 },
    },
    position: 'Teknolog',
    phoneNumber: '',
    contactPerson: false,
  },
  'Arran Gabriel': {
    hide: false,
    name: 'Arran Gabriel',
    email: 'arran.gabriel@blank.no',
    image: {
      path: '/public/val/arran_c2dc6.jpg',
      width: 1200,
      height: 1800,
      mimeType: 'image/jpeg',
      hotspot: { x: 0.510899182561308, y: 0.296 },
    },
    position: 'Teknolog',
    phoneNumber: '',
    contactPerson: false,
  },
  'Hege Aalvik': {
    hide: false,
    name: 'Hege Aalvik',
    email: 'hege.aalvik@blank.no',
    image: {
      path: '/public/val/img_7437_f16c8.jpg',
      width: 3787,
      height: 5681,
      mimeType: 'image/jpeg',
    },
    position: 'Teknolog',
    phoneNumber: '',
    contactPerson: false,
  },
  'Sander Neraas': {
    hide: false,
    name: 'Sander Neraas',
    email: 'sander.neraas@blank.no',
    image: {
      path: '/public/val/sander_5_f44e5.jpg',
      width: 3508,
      height: 4724,
      mimeType: 'image/jpeg',
    },
    position: 'Teknolog',
    phoneNumber: '',
    contactPerson: false,
  },
  'Sofia Henden': {
    hide: false,
    name: 'Sofia Henden',
    email: 'Sofia.henden@blank.no',
    image: {
      path: '/public/val/img_9719_6a9cb.jpg',
      width: 3984,
      height: 2656,
      mimeType: 'image/jpeg',
    },
    position: 'Teknolog',
    phoneNumber: '',
    contactPerson: false,
  },
  'Olav Selnes Lorentzen': {
    hide: false,
    name: 'Olav Selnes Lorentzen',
    email: 'olav.lorentzen@blank.no',
    image: {
      path: '/public/val/img_9815_2e6a4.jpg',
      width: 3984,
      height: 2656,
      mimeType: 'image/jpeg',
    },
    position: 'Teknolog',
    phoneNumber: '',
    contactPerson: false,
  },
  'Dina Louise Bahr Bugge': {
    hide: false,
    name: 'Dina Louise Bahr Bugge',
    email: 'dina.bugge@blank.no',
    image: {
      path: '/public/val/dina_02f25.png',
      width: 3508,
      height: 4961,
      mimeType: 'image/png',
    },
    position: 'Designer',
    phoneNumber: '',
    contactPerson: false,
  },
  'Tobias Paulsen': {
    hide: false,
    name: 'Tobias Paulsen',
    email: ' tobias.paulsen@blank.no',
    image: {
      path: '/public/val/tobias_redigert_c901c.png',
      width: 3508,
      height: 4961,
      mimeType: 'image/png',
    },
    position: 'Teknolog',
    phoneNumber: '',
    contactPerson: false,
  },
  'Lene Utklev Gaupen': {
    hide: false,
    name: 'Lene Utklev Gaupen',
    email: 'lene.utklev.gaupen@blank.no',
    image: {
      alt: 'Lene Utklev Gaupen',
      path: '/public/val/lene_redigert(1)_04d57.png',
      width: 3508,
      height: 4961,
      mimeType: 'image/png',
    },
    position: 'Designer',
    phoneNumber: '90478029',
    contactPerson: false,
  },
  'Emil Grønnbeck': {
    hide: false,
    name: 'Emil Grønnbeck',
    email: 'emil.gronnbeck@blank.no',
    image: {
      alt: 'Emil Grønnbeck',
      path: '/public/val/emil_2eb3e.jpg',
      width: 2048,
      height: 1365,
      mimeType: 'image/jpeg',
    },
    position: 'Teknolog',
    phoneNumber: '',
    contactPerson: false,
  },
});
